import {
    ACC_USER_AVATAR_VIEW_RESET,
    ACC_USER_AVATAR_VIEW,
    ACC_USER_AVATAR_VIEW_SUCCESS,
    ACC_USER_AVATAR_VIEW_FAIL,
    ACC_USER_AVATAR_VIEW_CLEAR_CACHE
} from './constants';

//
export const AccountUserAvatarViewReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case ACC_USER_AVATAR_VIEW_RESET:
            ret.loading = false;
            ret.loadSuccess = null;
            ret.error = null;
            ret.blobUrl = null;
            break;
        case ACC_USER_AVATAR_VIEW_CLEAR_CACHE:
            ret.blobUrls = [];
            break;
        case ACC_USER_AVATAR_VIEW:
            ret.loading = true;
            ret.loadSuccess = null;
            ret.error = null;
            break;
        case ACC_USER_AVATAR_VIEW_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.blobUrl = data.blobUrl;
            ret.blobUrls = data.blobUrls;
            break;
        case ACC_USER_AVATAR_VIEW_FAIL:
            ret.loading = false;
            ret.loadSuccess = false;
            ret.error = data;
            break;
        default:
            return {...state};
    }
    return ret;
}